<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software; you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with this program;
 * if not, write to the Free Software Foundation, Inc., 51 Franklin Street, Fifth Floor,
 * Boston, MA  02110-1301, USA
 */
 -->

<template>
  <div class="orangehrm-background-container">
    <div class="orangehrm-card-container">
      <oxd-text tag="h6" class="orangehrm-main-title">
        {{ $t('attendance.edit_fingerspot_attendance') }}
      </oxd-text>
      <oxd-divider />
      <oxd-form :loading="isLoading" @submit-valid="onSave">
        <oxd-grid :cols="4" class="orangehrm-full-width-grid">
          <oxd-grid-item>
            <oxd-input-field
              v-model="fingerspotAttendance.ioMode"
              type="select"
              :label="$t('attendance.attendance_io_mode')"
              :options="ioMode"
              :show-empty-selector="false"
            />
          </oxd-grid-item>
          <oxd-grid-item>
            <oxd-input-field
              v-model="fingerspotAttendance.pin"
              :label="$t('general.employee_id')"
              disabled
            />
          </oxd-grid-item>
          <oxd-grid-item>
            <oxd-input-field
              v-model="fingerspotAttendance.employee.fullName"
              :label="$t('general.full_name')"
              disabled
            />
          </oxd-grid-item>
          <oxd-grid-item>
            <oxd-input-field
              v-model="fingerspotAttendance.scanDate.date"
              :label="$t('general.time')"
              disabled
            />
          </oxd-grid-item>
        </oxd-grid>

        <oxd-divider />
        <oxd-form-actions>
          <required-text />
          <oxd-button
            display-type="ghost"
            :label="$t('general.cancel')"
            @click="onCancel"
          />
          <submit-button />
        </oxd-form-actions>
      </oxd-form>
    </div>
  </div>
</template>

<script>
import {navigate} from '@ohrm/core/util/helper/navigation';
import {APIService} from '@ohrm/core/util/services/api.service';
import moment from 'moment/moment';
import usei18n from '@/core/util/composable/usei18n';

const fingerspotAttendanceModel = {
  id: null,
  pin: '',
  workCode: '',
  sn: '',
  verifyMode: '',
  scanDate: {
    date: '',
    timezone_type: null,
    timezone: '',
  },
  ioMode: '',
  status: null,
  employee: {
    empNumber: null,
    employeeId: '',
    firstName: '',
    lastName: '',
    fullName: '',
  },
};
export default {
  props: {
    fingerspotId: {
      type: String,
      required: true,
    },
  },
  setup() {
    const {$t} = usei18n();
    const ioMode = [
      {
        id: 1,
        value: '1',
        label: $t('attendance.punch_in'),
      },
      {
        id: 2,
        value: '2',
        label: $t('attendance.punch_out'),
      },
    ];
    const http = new APIService(
      window.appGlobal.baseUrl,
      '/api/v2/admin/fingerspot-attendance',
    );
    return {
      http,
      ioMode,
    };
  },
  data() {
    return {
      isLoading: false,
      fingerspotAttendance: {...fingerspotAttendanceModel},
    };
  },
  created() {
    this.isLoading = true;
    this.http
      .get(this.fingerspotId)
      .then((response) => {
        const {data} = response.data;
        this.fingerspotAttendance.id = data.id;
        this.fingerspotAttendance.pin = data.pin;
        // this.fingerspotAttendance.sn = data.sn;
        // this.fingerspotAttendance.verifyMode = data.verifyMode;
        // this.fingerspotAttendance.status = data.status;
        this.fingerspotAttendance.scanDate.date = moment(
          data.scanDate.date,
          'YYYY-MM-DD HH:mm:ss.SSSSSS',
        ).format('dddd, D MMMM YYYY hh:mm:ss A');
        this.fingerspotAttendance.employee.fullName = data.employee.fullName;
        this.fingerspotAttendance.ioMode = this.ioMode.find(
          (opt) => opt.value === data.ioMode,
        );
      })
      .finally(() => {
        this.isLoading = false;
      });
  },
  methods: {
    onSave() {
      this.isLoading = true;
      this.http
        .update(this.fingerspotId, {
          //   pin: this.fingerspotAttendance.pin,
          //   sn: this.fingerspotAttendance.sn,
          //   verifyMode: this.fingerspotAttendance.verifyMode,
          //   scanDate: this.fingerspotAttendance.scanDate.date,
          //   status: this.fingerspotAttendance.status,
          ioMode: this.fingerspotAttendance.ioMode.value,
        })
        .then(() => {
          return this.$toast.updateSuccess();
        })
        .then(() => {
          this.onCancel();
        });
    },
    onCancel() {
      navigate('/attendance/viewFingerspotAttendance');
    },
  },
};
</script>
